import React from 'react';
import './App.css';
import Placeholder from './assets/images/Portrait_Placeholder.png';
import Banxico from './assets/images/banxico.png';
import SVB from './assets/images/svb.png';
import Inflacion from './assets/images/inflacion.png';
import PIB from './assets/images/pib.png';
import GDP from './assets/images/gdp.png';
import SuperPeso from './assets/images/superPeso.png';
import Recesion from './assets/images/recesion.png';
import Economia from './assets/images/economia.png';


function Threads() {
  return (
    <div className="Threads">
      <div className="main-content">
        <div className="page-title">
          <h1> Libreria de Hilos Valiosos</h1>
          </div>
          <div className="page-subtitle">
            <p>"Cátedras con anatomía de tweets sobre temas complejos, técnicos que espantan pero escritos de manera amena, coloquial y práctica."</p>
          </div>
        <div className="image-row">
          <div className="img-with-text">
            <a href="https://twitter.com/EconFinTalked/status/1669078171717894145"><img className="thread-image" src={Recesion} alt="thread" /></a>
            <p>Ya neta: ¿Qué es una recesión?</p>
          </div>

          <div className="img-with-text">
            <a href="https://twitter.com/EconFinTalked/status/1682826516617388032"><img className="thread-image" src={SuperPeso} alt="thread" /></a>
            <p>El sonadísimo "Súper Peso"</p>
          </div>

        </div>
        <div className="image-row">
          <div className="img-with-text">
            <a href="https://twitter.com/EconFinTalked/status/1666475979693506562"><img className="thread-image" src={GDP} alt="thread" /></a>
            <p>Hablemos del PIB</p>
          </div>

          <div className="img-with-text">
            <a href="https://twitter.com/EconFinTalked/status/1664778874511826944"><img className="thread-image" src={PIB} alt="thread" /></a>
            <p>Corrección Predicción crecimiento MX</p>
          </div>

          <div className="img-with-text">
            <a href="https://twitter.com/EconFinTalked/status/1660669859993378816"><img className="thread-image" src={Inflacion} alt="thread" /></a>
            <p>Fenómeno que todos vivimos pero muy pocos comprenden</p>
          </div>

        </div>
        <div className="image-row">
          <div className="img-with-text">
            <a href="https://twitter.com/EconFinTalked/status/1660352153301688320"><img className="thread-image" src={SVB} alt="thread" /></a>
            <p>¿Porqué quebró SVB?</p>
          </div>

          <div className="img-with-text">
            <a href="https://twitter.com/EconFinTalked/status/1659631536650752001"><img className="thread-image" src={Banxico} alt="thread" /></a>
            <p>¿Qué es o con qué se come Banxico?</p>
          </div>

          <div className="img-with-text">
            <a href="https://twitter.com/EconFinTalked/status/1659282253963460609"><img className="thread-image" src={Economia} alt="thread" /></a>
            <p>¿Pos qué somos?</p>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Threads;